import axios from "axios";
import { configSettings } from "../config/configSettings";

const api = axios.create({
  baseURL: configSettings.appURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
